import React from 'react';
import PropTypes from 'prop-types';
import {
  SimpleModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '@ami/react/core';
import { QuoteCustomLineItem } from '../../../quotes/otherQuoteEntities';
import { FormInput } from '@ami/react/core';
import { FormReadonly } from '@ami/react/core';
import { InvisibleSubmit } from '@ami/react/core';
import { formatPrice } from '../../../quotes/priceFormatter';
import { makeValidable } from '@ami/react/core';
import { howManyLinesIn } from '@ami/react/core';
import { SubLineItemsFormComponent } from '../../../SubLineItemsFormComponent';

const FormData = makeValidable(
  ({ item, save, updateItem, updateSubLineItems }) => {
    return (
      <form className="container" onSubmit={save}>
        <div className="row">
          <div className="col-md-8">
            <FormInput
              label="Name"
              value={item.name}
              onChange={(e) => updateItem(e, 'name')}
              required
            />
          </div>
          <div className="col-md-4">
            <FormInput
              label="Part Number"
              value={item.basePartNumber}
              onChange={(e) => updateItem(e, 'basePartNumber')}
              required
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-8">
            <FormInput
              label="Description"
              type="textarea"
              rows={Math.max(howManyLinesIn(item.description), 2)}
              value={item.description}
              onChange={(e) => updateItem(e, 'description')}
              required
            />
          </div>
          <div className="col-md-4">
            <FormInput
              type="number"
              min="1"
              label="Lead Time (days)"
              value={item.leadTimeDays}
              onChange={(e) => updateItem(e, 'leadTimeDays')}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <FormInput
              prependValue="$"
              type="number"
              min="1"
              label="D. NET"
              value={item.dNetPrice}
              onChange={(e) => updateItem(e, 'dNetPrice')}
              required
            />
          </div>
          <div className="col-md-8">
            <SubLineItemsFormComponent
              lineItem={item}
              onUpdate={(subLineItems) => updateSubLineItems(subLineItems)}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-3">
            <FormReadonly
              label="Unit Price"
              value={formatPrice(item.getUnitPrice())}
            />
          </div>
          <div className="col-md-3">
            <FormInput
              type="number"
              min="1"
              label="Quantity"
              value={item.quantity}
              onChange={(e) => updateItem(e, 'quantity')}
              required
            />
          </div>
          <div className="col-md-3">
            <FormReadonly label="Price" value={formatPrice(item.getTotal())} />
          </div>
        </div>
        <InvisibleSubmit />
      </form>
    );
  }
);

export default class ReviewQuoteCustomLineItemEditModal extends React.Component {
  constructor(props) {
    super(props);
    this.formDataRef = React.createRef();
  }

  state = {
    show: false,
    showValidations: false,
    customLineItem: null,
    editMode: false,
  };

  static propTypes = {
    onCustomLineItemEdited: PropTypes.func.isRequired,
  };

  edit(customLineItem) {
    let lineItem = customLineItem || new QuoteCustomLineItem();

    this.setState({
      show: true,
      showValidations: false,
      customLineItem: lineItem,
      editMode: !!customLineItem,
    });
  }

  updateItem = (e, propertyName) => {
    const copy = this.state.customLineItem.clone();
    const value = e.target.value;

    // Check if value is a number
    if (!isNaN(value)) {
       // If it's a number, parse it to a float
       copy[propertyName] = parseFloat(value);
    } else {
       // If it's not a number, keep it as is
       copy[propertyName] = value;
    }

    this.setState({ customLineItem: copy });
  };

  updateSubLineItems = (subLineItems) => {
    const copy = this.state.customLineItem.clone();
    copy.subLineItems = subLineItems;

    this.setState({ customLineItem: copy });
  };

  hide = () => this.setState({ show: false });

  save = (e) => {
    if (e) e.preventDefault();
    this.setState({ showValidations: true }, () => {
      if (!this.formDataRef.current.isValid()) return;
      this.props.onCustomLineItemEdited(
        this.state.customLineItem,
        this.state.editMode
      );
      this.hide();
    });
  };

  render() {
    if (!this.state.show) return null;

    const item = this.state.customLineItem;
    const title = `${this.state.editMode ? 'Edit' : 'New'} Custom Line Item`;

    return (
      <SimpleModal show={this.state.show} size="lg">
        <ModalHeader title={title} />
        <ModalBody>
          <FormData
            item={item}
            save={this.save}
            updateItem={this.updateItem}
            updateSubLineItems={this.updateSubLineItems}
            ref={this.formDataRef}
            showValidations={this.state.showValidations}
          />
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-secondary" onClick={this.hide}>
            Cancel
          </button>
          <button className="btn btn-primary" onClick={this.save}>
            Save
          </button>
        </ModalFooter>
      </SimpleModal>
    );
  }
}
